import React, { useState } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Axios from "axios";
import moment from "moment";
import Controls from "../../subDealerManagement/subdealer/Controls";
import { useDispatch, useSelector } from "react-redux";
import {
  convertToCurrencyFormat,
  convertToCurrencyFormatQuantaty,
  DataFormat,
} from "../../../../_helpers";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import Popup from "../../../../components/Popup/Popup";
import ItemEdit from "./ItemEdit";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import { getDealerRetationShipListAction } from "../../../../_actions/subDealer.action";

import { API_URL_ADMIN, API_URL_LMS } from "../../../../Constant/index";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { ToastContainer, toast } from 'react-toastify';

const AllocationInventoryList = (props) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [isdelete, setIsdelete] = useState(false);
  const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState(null);
  const [headerName, setHeaderName] = useState("Add Contact");
  const [loading, setLoading]=React.useState(false)
  const [tableData, setTableData] = useState([]);
  const { dataTable } = props;
  const dealerListWithRelationship = useSelector(
    (state) => state.dealerListWithRelationship
  );
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [pageSize, setPageSize] = React.useState(25);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  // let [searchParams, setSearchParams] = useSearchParams();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const subdealerNumber = params.get("subDelearNumber");
  const [searchedRows, setSearchedRows] = useState(null)
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    message: "",
    severity: "",
    open: false,
  });
  const excelDataTransformConfig = {
    isMarkDelete: { true: "Yes", false: "No" },
    isautoallocation: { true: "Yes", false: "No" },
    ismanaualallocation: { true: "Yes", false: "No" },
  };

  const getproductDetails = () => {   
    setLoading(true)
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };  
    Axios.get(API_URL_LMS+`loyalty/inventory-item?productCode=${props.itemDetails.productCode}&customerId=${props.itemDetails.customerId}&billingMonths=${props.itemDetails.billingMonth}&billingYear=${props.itemDetails.billingYear}&expiryDate=${props.itemDetails.expirationDate}`,requestOptions)
      .then((response) => {
        setLoading(false)
          if(response.data.status===200)
          {
            let formattedData = response.data.data.map((item) => { 
              return ({ ...item, 
                formattedAutoAllocatedQty: item.autoAllocation == true ? 
                +convertToCurrencyFormatQuantaty(item.autoAllocated) : 
                +convertToCurrencyFormatQuantaty(+item.manuallyAllocated),
                faq: convertToCurrencyFormatQuantaty(item.formattedAutoAllocatedQty),
                pr: convertToCurrencyFormat(item.pointsReceived),
              }) 
              })
                setTableData(formattedData)   

          }else{
            setTableData([])
          }
        
      })
      .catch((error) => {
        
      });
    }

  
  React.useEffect(() => {
getproductDetails()
  }, []);

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const onEditClick =async (e) => {
          const isAllow = await isPermission("SoldToManagement-AllocationInventory-CCAllocationInventoryItem-edit")
          if (!isAllow) {
              toast.success(authorizedMessage, {
                  position: toast.POSITION.TOP_RIGHT
              });
              return 0;
          }

          setHeaderName(`Edit`);
          setRecordForEdit(params.row);
          setOpenPopup(true);
          setIsAddEdit(false);
          props.setIsAddEdit(false);
        };
        return (
          <>
            {params.row.autoAllocation === false && (
              <div className="Action">
                <EditIcon className="EditIcon" onClick={onEditClick} />
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "subDealerId",
      headerName: "Sub Dealer Number",
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "subDealerName",
      headerName: "Sub Dealer Name",
      headerAlign: "center",
      align: "left",
      align: "left",
      width: 200,
      // renderCell: RenderCellExpand,
    },
    {
      field: "productCode",
      headerName: "Product Number",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: ({ row }) => {
        return <>{row.productCode ? DataFormat(row.productCode) : ""}</>;
      },
    },
    {
      field: "productName",
      headerName: "Product Name",
      headerAlign: "center",
      align: "left",
      width: 250,
      renderCell: RenderCellExpand,
    },
    {
      field: "formattedAutoAllocatedQty",
      headerName: "Allocated Quantity",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return <div>{ convertToCurrencyFormatQuantaty(row.formattedAutoAllocatedQty) }</div>;
      },
    },
    {
      field: "pointsReceived",
      headerName: "Points",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.00',
      renderCell: ({ row }) => {
        return <div>{row.pointsReceived != null ? convertToCurrencyFormat(row.pointsReceived) : null}</div>;
      },
    },
    {
      field: "isautoallocation",
      headerName: "Auto Allocated",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
              <Controls.Checkbox
                value={row.autoAllocation === true ? true : false}
              />
          </div>
        );
      },
    },
    {
      field: "ismanaualallocation",
      headerName: "Manual Allocated",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
              <Controls.Checkbox
                value={row.autoAllocation === false ? true : false}
              />
          </div>
        );
      },
    },
    {
      field: "isMarkDelete",
      headerName: "Mark Delete",
      headerAlign: "center",
      align: "center",
      renderCell: ({ row }) => {
        return (
          <div className="MarkDelChkBox">
              <Controls.Checkbox
                value={
                  row.isMarkDelete === "true"
                    ? true
                    : false
                }
              />
          </div>
        );
      },
    },
    {
      field: "createdBy",
      headerName: "Created By",
      headerAlign: "center",
      align: "left",
      format: 'DD-MM-yyyy',
      renderCell: RenderCellExpand
    },
    { field: 'faq', headerName: 'auto allocation', hide: true },
    { field: 'pr', headerName: 'Pts rcvd', hide: true },
  ];

  React.useEffect(() => {
    if (isAddEdit === true && openPopup === false){
      getproductDetails()
    }
  }, [isAddEdit, openPopup]);
//export same as report starts here
const onExportClick=()=>{
  const url = `export/allocationInventory-item`;
  setExportState("Exporting...");
  let filters={
    "productCode":props.itemDetails.productCode,
    "customerId":props.itemDetails.customerId,
    "billingMonths":props.itemDetails.billingMonth,
    "billingYear":props.itemDetails.billingYear,
    "expiryDate":props.itemDetails.expirationDate
  }
  Axios({
      method: "POST",
      url: API_URL_LMS + url,
      data: filters,
      headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
          "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
  })
      .then(async (response) => {
          setExportState("Export");
          setOpen(true);
          setFileUrl(response.data.data);
          exportExcelFile(response.data.data);
      })
      .catch((err) => { setExportState("Export");});
}


function exportExcelFile(file_url) {
setExportFiles([])
Axios({
    method: "GET", url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
    headers: {
        "Content-Type": "application/json",
        'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
        'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
    }
})
    .then(async (response) => {
        const newRes = Array.isArray(response.data.data) ? response.data.data : []
        setExportFiles(newRes)
    }).catch((err) => {
        // setExportState({ btnName: "EXPORT" });
    })
}
//export same as report ends here.

function modifyColumns(columns) {
    columns = columns.filter((item)=>!["actions","faq", "pr"].includes(item.field));
    // columns = columns.filter(function(el) { return el.field != "actions"; });
  return columns.map((item) => {
    return ({
      label: item.headerName,
      value: item.field,
      ...item
    })
  })
}

function modifyRows(rowdata) {
  // let filteredRow = searchedRows.map((item) => item.model);
  let filteredRow = rowdata.map((item) => item.model);
  const data = filteredRow.map((item) => {
    return ({
      ...item,
      // creationDate : item.creationDate ? new Date(item.creationDate) :""
      isMarkDelete : item.isMarkDelete === "true" ? true : false,
      isautoallocation:item.autoAllocation === true ? true : false,
      ismanaualallocation:item.autoAllocation === false ? true : false,
    })
  })
  return data
}

function callExcelExport(data){
  const fileName = `InventoryItemList_Report_${moment(new Date()).format("DDMMyyyy")}`
  const sheetName = `Item_List_Report_`
  onExportExcel(modifyColumns(columns), modifyRows(data), fileName,sheetName)
}

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={state.open}
        autoHideDuration={6000}
        key={"topright"}
      >
        <Alert
          severity={state.severity}
          sx={{ width: "100%" }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                setState({ open: false });
              }}
            >
              Close
            </Button>
          }
        >
          {state.message}
        </Alert>
      </Snackbar>

      <div
        className="ContactDataGridContainer"
      >
        <ExportExcelPopup
            title={"Customer"}
            fileName={"customer"}
            setOpen={setOpen}
            open={open}
            exportExcelFile={exportExcelFile}
            fileUrl={fileUrl}
            exportFiles={exportFiles}
        />
        <DataGridProMUI
          rows={tableData ? tableData : []}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onExportClick={onExportClick}
          exportState={exportState}
          loading={loading}
          setSearchedRows={setSearchedRows}
          callExcelExport={callExcelExport}
          defaultStateChange={false}
        />
      </div>
      {/* popup is a reusable custom dialog component */}
      <Popup
        title={headerName}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        maxWidth={"xs"}
        p={3}
      >
        <ItemEdit
          setIsAddEdit={setIsAddEdit}
          setOpenPopup={setOpenPopup}
          productId={props.productId}
          recordForEdit={recordForEdit}
        />
      </Popup>
      <ToastContainer />
    </>
  );
};

export default AllocationInventoryList;
